import http from '@http'

// 短剧录入
export function skitEntry(data) {
  return http.post('/right-protect/video/input/save', data)
}
